export enum IconScope {
  GLOBAL = 'GLOBAL',
  DEVICE = 'DEVICE',
  SENSOR = 'SENSOR',
  COMPANY = 'COMPANY',
}
